export default __webpack_public_path__ + "static/artifakt-element-light-30ca0033a7c42bf408a536ac61dd2370.eot";